// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"761":"ae9fba77c41682f7","955":"9036b2fc3e43e0ca"}[chunkId] + ".js";
};